import React, { Component } from 'react';
import Gambar from '../images/a.jpg';
class Home extends Component {
    
    constructor(props){
        
        super(props)
        
        this.state = {
            
            geometri : 'hello',
            
            daerah : null,
            
            kecepatanAngin : 0 + ' m/s',
            suhu: 0,
            tekanan: 0 + ' hPa',
            jarakPandang: 0 + ' km',
            awan: 0,
            keterangan: 'Belum ada keterangan apapun',
            timezone: 'Tidak diketahui'
        }
        
    }
    
    
    handleInput = (e) => {
        
        this.setState({
            daerah : e.target.value,
            geometri : null
        });
        
    }
    
    handleSubmit = (f) => {
        
        const wilayah = document.querySelector('#wilayah');
        
        wilayah.value = ''
        
        f.preventDefault();
        
        const proxy = "https://cors-anywhere.herokuapp.com/";
        
        let url = "https://api.opencagedata.com/geocode/v1/json?q="+ this.state.daerah +"&key=101a9c15f33d4852a45cdaab6c51f3a4";
        const that = this;
        fetch(`${proxy}${url}`)
        .then(res => res.json())
        .then( (result) => {
        
            
            try{
                if( result !== null ){
                    if( result.results.length > 0 ){

                        that.setState({
                            geometri: result.results[0].geometry
                        })

                    }else{
                        alert('Lokasi Tidak ditemukan')
                    }
                }else{


                    alert('Lokasi tidak ditemukan')

                }    
            }
            catch(err){
                alert(err);
            }
            
            
        },
              (error) => {
            console.log(error)
        }
             )
        
        
        // ajax menambil cuaca
        
        setTimeout(() => {
            
            if( this.state.geometri !== null ){

                    const url2 = "https://api.darksky.net/forecast/0abe209b3a80006bcb5210202298cd53/"+ this.state.geometri.lat +"," + this.state.geometri.lng + "?lang=id"


                fetch(`${proxy}${url2}`)
                .then(res => res.json())
                .then( (hasil) => {

                    this.setState({

                        kecepatanAngin: hasil.currently.windSpeed + ' km',
                        jarakPandang : hasil.currently.visibility + ' km',
                        suhu: parseInt((parseInt(hasil.currently.temperature) - 32) * 5 / 9),
                        tekanan: hasil.currently.pressure + ' hPa',
                        awan: hasil.currently.cloudCover,
                        keterangan : hasil.currently.summary,
                        timezone : hasil.timezone

                    })

                },
                     (error) => {
                    console.log(error)
                })
            
            }
            
        }, 2000)
    }
    
    render(){
        return(
            <>
            
            <div className='baner'>
            
            <img src={Gambar} alt='Gambar banner home'/>
            <div id='kolom-teks'>
            <div className='container isi-teks'>
            
            <h3>Mau kemana hari ini ?</h3>
            <p>Pastikan cuaca hari ini bagus untuk memulai petualanganmu</p>
            <br/>
            
            <form action='' method='post' className='form' onSubmit={this.handleSubmit}>
            <div id='kolom-form'>
            <input type='text' onChange={this.handleInput} id='wilayah' placeholder='Nama lokasi'/>
            
            <button type='submit' className='btn-cek'>Cek</button>
            </div>  
            </form>
            
            </div>
            </div>
            {/* akhir kolom teks  */}
            
            </div>
            
            
            {/* bagian hasil perkiraan cuaca */}
            <center>
            
            <div className='box-cuaca box-shadow'>
            
            <div id='baris'>
            
            <div className='suhu'>
            <h1>{this.state.suhu} &#8451;</h1>
            <span>TM : {this.state.timezone}</span>
            <br/>
            <span><i className='fa fa-map-marker'></i> {this.state.daerah}</span>
            </div>
            
            <div id='keterangan'>
            <p> {this.state.keterangan} </p>
            </div>
            
            
            </div>
            
            {/* bagian keteangan lainnya */}
            
            <div id='baris'>
            
            <div className='kotak' title='Kecepatan Angin'>
            <i className="fas fa-wind"></i>
            <span>{this.state.kecepatanAngin}</span>
            <small>Kecepatan Angin</small>
            </div>
            
            <div className='kotak' title='Jarak Pandang'>
            <i className="fas fa-binoculars"></i>
            <span>{this.state.jarakPandang}</span>
            <small>Jarak Pandang</small>
            </div>
            
            <div className='kotak' title='Suhu'>
            <i className="fas fa-temperature-low"></i>
            <span>{ this.state.suhu } &#8451;</span>
            <small>Suhu</small>
            </div>
            
            <div className='kotak' title='Tekanan'>
            <i className="fas fa-thermometer"></i>
            <span>{ this.state.tekanan }</span>
            
            <small>Tekanan</small>
            </div>
            
            <div className='kotak' title='Tutupan Awan'>
            <i className="fa fa-cloud"></i>
            <span>{this.state.awan}</span>
            
            <small>Tutupan Awan</small>
            </div>
            
            
            </div>
            
            {/* akhir */}
            
            </div>
            </center>
            
            </>
        )
    }
    
}

export default Home;